import { MessageCircle } from "lucide-react";
import { waLink, WA_MESSAGES } from "@/config/site";

const VARIANTS = {
  teal: "bg-brand-teal text-white hover:bg-brand-charcoal",
  gold: "bg-brand-gold text-white hover:bg-brand-teal",
  white: "bg-white text-brand-teal hover:bg-brand-gold hover:text-white",
  coral: "bg-brand-coral text-white hover:bg-brand-teal",
};

const WhatsAppCTA = ({
  message = WA_MESSAGES.freeAssistance,
  label = "Get Free Assistance via WhatsApp",
  variant = "teal",
  testid = "whatsapp-cta",
  className = "",
}) => (
  <a
    href={waLink(message)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className={`inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm sm:text-base font-semibold shadow-[0_8px_30px_rgb(7,91,89,0.25)] hover:-translate-y-0.5 hover:shadow-[0_12px_40px_rgb(7,91,89,0.35)] transition-all duration-300 ${VARIANTS[variant]} ${className}`}
  >
    <MessageCircle className="h-5 w-5" />
    {label}
  </a>
);

export default WhatsAppCTA;
